import { Icon } from '@design/components/icon/Icon';
import clsx from 'clsx';
import React from 'react';

import styles from './MarketIndicator.module.scss';

interface MarketIndicatorProps {
  className?: string;
  isMarketOpen: boolean;
  liveText: string;
  closeText: string;
}

export const MarketIndicator = ({
  className,
  isMarketOpen,
  liveText,
  closeText,
}: MarketIndicatorProps) => {
  return (
    <div
      data-testid="market-status"
      className={clsx(
        styles.market,
        { [styles.marketOpen]: isMarketOpen },
        className
      )}
    >
      <Icon
        className={clsx(styles.dotIcon, {
          [styles.marketOpen]: isMarketOpen,
        })}
        iconName="Dot"
        size={16}
      />
      {isMarketOpen ? liveText : closeText}
    </div>
  );
};
